import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'autumnRust',
      d: 'M-6,-6.5h0.5v0.5h-0.5zM-6,-6h2v0.5h-2zM6,-6h0.5v0.5h-0.5zM-6,-5.5h3v0.5h-3zM4.5,-5.5h2v0.5h-2zM-6,-5h2.5v0.5h-2.5zM4,-5h2.5v0.5h-2.5zM-6.5,-4.5h0.5v0.5h-0.5zM-4.5,-4.5h1v0.5h-1zM3.5,-4.5h3v0.5h-3zM-6.5,-4h2v0.5h-2zM3.5,-4h2.5v0.5h-2.5zM-6.5,-3.5h3.5v0.5h-3.5zM6,-3.5h0.5v0.5h-0.5zM-6.5,-3h3v1h-3zM3.5,-3h3v1.5h-3zM-6,-2h2.5v0.5h-2.5zM-1.5,-2h0.5v0.5h-0.5zM-6.5,-1.5h0.5v0.5h-0.5zM3.5,-1.5h1v0.5h-1zM-6.5,-1h3.5v0.5h-3.5zM4.5,-1h2v0.5h-2zM-6.5,-0.5h3v1h-3zM3.5,-0.5h3.5v1h-3.5zM-6.5,0.5h3.5v0.5h-3.5zM3.5,0.5h3v0.5h-3zM-4.5,1h2.5v0.5h-2.5zM2.5,1h1.5v0.5h-1.5zM-2,1.5h1v0.5h-1z',
    },
    {
      paint: 'sandcastleWall',
      d: 'M-4,-8h1.5v0.5h-1.5zM4,-8h1.5v0.5h-1.5zM-4.5,-7.5h2.5v0.5h-2.5zM2.5,-7.5h3v0.5h-3zM-6,-7h1v0.5h-1zM-4.5,-7h3.5v0.5h-3.5zM2,-7h2.5v0.5h-2.5zM5,-7h1v0.5h-1zM-5.5,-6.5h4.5v0.5h-4.5zM2,-6.5h4.5v0.5h-4.5zM-4,-6h1.5v0.5h-1.5zM2,-6h4v0.5h-4zM1.5,-5.5h3v0.5h-3zM1.5,-5h1v0.5h-1z',
    },
    {
      paint: 'oakBrown',
      d: 'M-1,-6.5h0.5v0.5h-0.5zM-2.5,-6h2v0.5h-2zM-3,-5.5h2.5v0.5h-2.5zM-3.5,-5h2.5v0.5h-2.5zM2.5,-5h1.5v0.5h-1.5zM-3.5,-4.5h1v0.5h-1zM1,-4.5h2.5v1.5h-2.5zM-2.5,-4h1.5v0.5h-1.5zM-3,-3.5h2v0.5h-2zM-3.5,-3h2.5v1h-2.5zM1,-3h1v0.5h-1zM2,-2.5h1.5v0.5h-1.5zM-3.5,-2h2v0.5h-2zM1,-2h2.5v1h-2.5zM-1.5,-1.5h0.5v0.5h-0.5zM-3,-1h2v0.5h-2zM1,-1h1.5v0.5h-1.5zM-3.5,-0.5h2v1h-2zM2.5,-0.5h1v0.5h-1zM1,0h2.5v0.5h-2.5zM-3,0.5h2v0.5h-2zM1.5,0.5h2v0.5h-2zM-2,1h1v0.5h-1zM2,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'wheat',
      d: 'M-6,-4.5h1.5v0.5h-1.5zM-2.5,-4.5h1.5v0.5h-1.5zM-4.5,-4h2v0.5h-2zM6,-4h0.5v0.5h-0.5zM3.5,-3.5h2.5v0.5h-2.5zM2,-3h1.5v0.5h-1.5zM1,-2.5h1v0.5h-1zM-6.5,-2h0.5v0.5h-0.5zM-6,-1.5h4.5v0.5h-4.5zM4.5,-1.5h2v0.5h-2zM2.5,-1h2v0.5h-2zM1,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'waterLight',
      d: 'M-0.5,-3.5h0.5v0.5h-0.5zM-0.5,-3h1v1h-1zM-1,-2h1.5v0.5h-1.5zM-1,-1.5h1v1h-1zM-1.5,-0.5h1.5v0.5h-1.5zM-1.5,0h2.5v0.5h-2.5zM-1,0.5h2.5v0.5h-2.5zM-1,1h3v0.5h-3zM-0.5,1.5h2.5v0.5h-2.5z',
    },
    { paint: 'palm', d: 'M-5,-7.5h0.5v1h-0.5zM4.5,-7h0.5v0.5h-0.5z' },
  ],
  pixels: 407,
};
export const sprites: readonly PixelSprite[] = [variant0];
